import { useCallback, useMemo, useRef } from "react";
import debounce from 'lodash/debounce';
import { useSelector } from "react-redux";
import { Input } from "../../../../components/ui/input";
import SelectListInput from "../../../../components/SelectListInput";

const TableViewEntry = ({
    index,
    columns,
    dataTypes,
    source,
    sourceType,
    destination,
    destType,
    addColumns = false,
    setType = () => {},
    changeMappedField = () => {},
    errors,
    viewOnly = false
  }) => {
    const { activeTab, uploadData } = useSelector((state) => state.Uploads);
  
    const destinationValue = useMemo(() => {
      return destination && destType 
        ? addColumns 
          ? destination 
          : `${destination} (${destType})` 
        : '';
    }, [destination, destType, addColumns]);
  
    const debouncedChangeMappedField = useRef(
      debounce((index, value) => {
        changeMappedField(index, value);
      }, 300)
    ).current;
  
    const handleInputChange = useCallback((e) => {
      debouncedChangeMappedField(index, e.target.value);
    }, [index, debouncedChangeMappedField]);
  
    return (
      <div className={`grid grid-cols-3 gap-1`}>
        <div>
          <Input defaultValue={`${source} (${sourceType})`} className="w-full bg-white !opacity-100" disabled={true} />
        </div>
        <div className={`${!addColumns && 'col-span-2'}`}>
          {addColumns ? (
            <div>
              <Input
                defaultValue={destinationValue}
                className="w-full bg-white !opacity-100"
                error={errors?.destination || ""}
                onChange={handleInputChange}
                disabled={uploadData.pending || viewOnly}
              />
              {errors?.destination && (
                <small className="text-destructive text-xs mt-1">{errors?.destination}</small>
              )}
            </div>
          ) : (
            <div>
              <SelectListInput
                type="map"
                list={columns}
                onChange={(value) => changeMappedField(index, value)}
                selectedValue={destinationValue}
                placeholder=""
                className="bg-white !opacity-100"
                error={errors?.destination || ""}
                disabled={activeTab === "additional_fields" || viewOnly}
                clearable={viewOnly ? false : true}
              />
            </div>
          )}
        </div>
        {addColumns && (
          <div>
            {uploadData.pending ? (
              <Input defaultValue={`${destType}`} className="w-full bg-white !opacity-100" disabled={true} />
            ) : (
              <SelectListInput
                type="list"
                list={dataTypes}
                onChange={(value) => {
                  if (value) setType(index, value);
                }}
                selectedValue={destType || null}
                placeholder=""
                className="bg-white !opacity-100"
                error={errors?.destType || ""}
                disabled={activeTab === "mapped_fields" || viewOnly}
              />
            )}
            {errors?.destType && (
              <small className="text-destructive text-xs mt-1">{errors?.destType}</small>
            )}
          </div>
        )}
      </div>
    );
  };
  
  export default TableViewEntry;
  